import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path opacity=\"0.4\" d=\"M17.53 7.77C17.46 7.76 17.39 7.76 17.32 7.77C15.77 7.72 14.54 6.45 14.54 4.89C14.54 3.3 15.83 2 17.43 2C19.02 2 20.32 3.29 20.32 4.89C20.31 6.45 19.08 7.72 17.53 7.77Z\" fill=\"#09926C\"></path><path opacity=\"0.4\" d=\"M20.7901 14.6999C19.6701 15.4499 18.1001 15.7299 16.6501 15.5399C17.0301 14.7199 17.2301 13.8099 17.2401 12.8499C17.2401 11.8499 17.0201 10.8999 16.6001 10.0699C18.0801 9.86992 19.6501 10.1499 20.7801 10.8999C22.3601 11.9399 22.3601 13.6499 20.7901 14.6999Z\" fill=\"#09926C\"></path><path opacity=\"0.4\" d=\"M6.4399 7.77C6.5099 7.76 6.5799 7.76 6.6499 7.77C8.1999 7.72 9.4299 6.45 9.4299 4.89C9.4299 3.3 8.1399 2 6.5399 2C4.9499 2 3.6499 3.29 3.6499 4.89C3.6599 6.45 4.8899 7.72 6.4399 7.77Z\" fill=\"#09926C\"></path><path opacity=\"0.4\" d=\"M6.55012 12.8501C6.55012 13.8201 6.76012 14.7401 7.14012 15.5701C5.73012 15.7201 4.26012 15.4201 3.18012 14.7101C1.60012 13.6601 1.60012 11.9501 3.18012 10.9001C4.25012 10.1801 5.76012 9.8901 7.18012 10.0501C6.77012 10.8901 6.55012 11.8401 6.55012 12.8501Z\" fill=\"#09926C\"></path><path d=\"M12.1198 15.87C12.0398 15.86 11.9498 15.86 11.8598 15.87C10.0198 15.81 8.5498 14.3 8.5498 12.44C8.5498 10.54 10.0798 9 11.9898 9C13.8898 9 15.4298 10.54 15.4298 12.44C15.4298 14.3 13.9698 15.81 12.1198 15.87Z\" fill=\"#09926C\"></path><path d=\"M8.8698 17.9399C7.3598 18.9499 7.3598 20.6099 8.8698 21.6099C10.5898 22.7599 13.4098 22.7599 15.1298 21.6099C16.6398 20.5999 16.6398 18.9399 15.1298 17.9399C13.4198 16.7899 10.5998 16.7899 8.8698 17.9399Z\" fill=\"#09926C\"></path>", 6)
const _hoisted_8 = [
  _hoisted_2
]

import { withDefaults } from 'vue';
  
  interface IProps {
    color?: string;
  }
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'PeopleGroupIcon',
  props: {
    color: {}
  },
  setup(__props: any) {

  const props = __props;
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_8))
}
}

})